/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The RootCategoriesInner model module.
 * @module model/RootCategoriesInner
 * @version v1
 */
export class RootCategoriesInner {
  /**
   * Constructs a new <code>RootCategoriesInner</code>.
   * @alias module:model/RootCategoriesInner
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>RootCategoriesInner</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RootCategoriesInner} obj Optional instance to populate.
   * @return {module:model/RootCategoriesInner} The populated <code>RootCategoriesInner</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new RootCategoriesInner();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('image_url'))
        obj.image_url = ApiClient.convertToType(data['image_url'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('categories_count'))
        obj.categories_count = ApiClient.convertToType(data['categories_count'], 'Number');
      if (data.hasOwnProperty('products_count'))
        obj.products_count = ApiClient.convertToType(data['products_count'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
RootCategoriesInner.prototype.id = undefined;

/**
 * @member {String} image_url
 */
RootCategoriesInner.prototype.image_url = undefined;

/**
 * @member {String} name
 */
RootCategoriesInner.prototype.name = undefined;

/**
 * @member {Number} categories_count
 */
RootCategoriesInner.prototype.categories_count = undefined;

/**
 * @member {Number} products_count
 */
RootCategoriesInner.prototype.products_count = undefined;

